import { getResponsiveImage, type ImageVariant } from '@/utils/images';

type OptimizedImageProps = {
  src: string;
  alt: string;
  className?: string;
  loading?: 'eager' | 'lazy';
  fetchPriority?: 'high' | 'low' | 'auto';
  decoding?: 'async' | 'sync' | 'auto';
  width?: number;
  height?: number;
  sizes?: string;
  variant?: ImageVariant;
};

export function OptimizedImage({
  src,
  alt,
  className,
  loading = 'lazy',
  fetchPriority,
  decoding = 'async',
  width,
  height,
  sizes,
  variant = 'hero',
}: OptimizedImageProps) {
  const responsive = getResponsiveImage(src, variant);
  const useAutoDimensions = variant === 'card';

  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      className={className}
      src={responsive?.src ?? src}
      srcSet={responsive?.srcSet}
      sizes={sizes ?? responsive?.sizes}
      alt={alt}
      loading={loading}
      fetchPriority={fetchPriority}
      decoding={decoding}
      width={useAutoDimensions ? width : width ?? responsive?.width}
      height={useAutoDimensions ? height : height ?? responsive?.height}
      onError={(event) => {
        const img = event.currentTarget;
        if (img.dataset.fallbackApplied === 'true') return;
        img.dataset.fallbackApplied = 'true';
        img.src = src;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
      }}
    />
  );
}
